export default __webpack_public_path__ + "static/media/Fulfillment_Devoluciones.999f4297.png";